import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './indicator.reducer';
import { IIndicator } from 'app/shared/model/indicator.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const IndicatorUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const indicatorEntity = useAppSelector(state => state.indicator.entity);
  const loading = useAppSelector(state => state.indicator.loading);
  const updating = useAppSelector(state => state.indicator.updating);
  const updateSuccess = useAppSelector(state => state.indicator.updateSuccess);

  const handleClose = () => {
    props.history.push('/indicator' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...indicatorEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          aggregateMethod: 'NONE',
          type: 'BASIC',
          ...indicatorEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.indicator.home.createOrEditLabel" data-cy="IndicatorCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.indicator.home.createOrEditLabel">Create or edit a Indicator</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="indicator-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <ValidatedField label={translate('fleetSenseApp.indicator.name')} id="indicator-name" name="name" data-cy="name" type="text" />
              <ValidatedField label={translate('fleetSenseApp.indicator.unit')} id="indicator-unit" name="unit" data-cy="unit" type="text" />
              <ValidatedField
                label={translate('fleetSenseApp.indicator.aggregateMethod')}
                id="indicator-aggregateMethod"
                name="aggregateMethod"
                data-cy="aggregateMethod"
                type="select"
              >
                <option value="NONE">{translate('fleetSenseApp.AggregateMethod.NONE')}</option>
                <option value="SUM">{translate('fleetSenseApp.AggregateMethod.SUM')}</option>
                <option value="AVG">{translate('fleetSenseApp.AggregateMethod.AVG')}</option>
                <option value="FIRST">{translate('fleetSenseApp.AggregateMethod.FIRST')}</option>
                <option value="LAST">{translate('fleetSenseApp.AggregateMethod.LAST')}</option>
              </ValidatedField>
              <ValidatedField
                label={translate('fleetSenseApp.indicator.description')}
                id="indicator-description"
                name="description"
                data-cy="description"
                type="textarea"
              />
              <ValidatedField label={translate('fleetSenseApp.indicator.type')} id="indicator-type" name="type" data-cy="type" type="select">
                <option value="BASIC">{translate('fleetSenseApp.IndicatorType.BASIC')}</option>
                <option value="MAINTENANCE">{translate('fleetSenseApp.IndicatorType.MAINTENANCE')}</option>
                <option value="PREMIUM">{translate('fleetSenseApp.IndicatorType.PREMIUM')}</option>
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/indicator" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default IndicatorUpdate;
